var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardSymbolsvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_5699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4053 2.67871H14.5898V22.3315H25.4053V2.67871Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2779 12.5029C15.2779 8.68345 17.029 5.03761 19.9818 2.6765C14.6256 -1.59433 6.8659 -0.656832 2.64273 4.79456C-1.58045 10.2112 -0.653409 18.0584 4.73715 22.3293C9.235 25.9057 15.5183 25.9057 20.0161 22.3293C17.029 19.9682 15.2779 16.3223 15.2779 12.5029Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9985 12.5029C39.9985 19.4126 34.4706 25.0029 27.6379 25.0029C24.8568 25.0029 22.1787 24.0654 20.0156 22.3293C25.3718 18.0584 26.2989 10.2112 22.0757 4.75983C21.4577 3.99595 20.771 3.26678 20.0156 2.6765C25.3718 -1.59433 33.1658 -0.656832 37.3547 4.79456C39.0714 6.98206 39.9985 9.69039 39.9985 12.5029Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8302 20.2508V19.8341H39.0019V19.7646H38.5898V19.8341H38.7615V20.2508H38.8302ZM39.6199 20.2508V19.7646H39.4825L39.3452 20.1119L39.2079 19.7646H39.0705V20.2508H39.1735V19.8688L39.3109 20.1813H39.4139L39.5512 19.8688V20.2508H39.6199Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_5699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardSymbolsvg);
export default __webpack_public_path__ + "static/media/mastercard_symbol.svg.500fd767efd094116cc3e0b378a7e7b9.svg";
export { ForwardRef as ReactComponent };